// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3nvvt","errorLogs":"styles_errorLogs__LtnR1"};